var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('layout-aside',{staticClass:"layout-silde"}),_c('layout-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }